import React from 'react';

// Hooks
import useScreenWidth from '~/hooks/useScreenWidth';

// Utils
import { ORDER_STATS } from '~/utils/constants';

// MUI Components
import { Box, Tooltip, Typography } from '@mui/material';

// Components
import HeaderCardSkeleton from './HeaderCardSkeleton';

// Styles
import './styles.scss';

const HeaderCard = (props) => {
    const { loading = false } = props;
    const screenWidth = useScreenWidth(1250);

    if (loading) {
        return <HeaderCardSkeleton />;
    }

    return (
        <Box className="headerCardContainer">
            {ORDER_STATS(props).map((item) => (
                <Box key={item.id} className={`headerCard ${!screenWidth ? 'responsiveClass' : ''}`}>
                    <Box className={`headerCardContent ${item.label === 'Order Number' ? 'orderNumber' : ''}`}>
                        <img src={item.icon} alt={item.label} />
                        <Box className="headerCardDetails" >
                            <Typography variant="body2" className="headerCardLabel">
                                {item.label}
                            </Typography>
                            {((item.key === 'orderName' && item.value && item.value !== '-') || (item.value && item.value.length > 23 && screenWidth)) ?
                                <Tooltip title={item.value}>
                                    <Typography variant="h4" sx={{ cursor: 'pointer'}} className="headerCardValue">
                                        {item.key === 'orderName' ? item.value : item.value.length > 24 ? item.value.slice(0, 24) + '...' : item.value || '-'}
                                    </Typography>
                                </Tooltip>
                                :
                                <Typography variant="h4" className="headerCardValue">
                                    {item.value || '-'}
                                </Typography>
                            }
                        </Box>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default HeaderCard; 